import { config } from './config';
import eventProxy from './eventProxy';

const fields = {
  'upload.UploadDoubleCheck': { type: Boolean, defaultValue: false },
  'general.Language': { type: String, defaultValue: config.defaultLanguage },
};

class Store {
  constructor() {
    this.sessionStorage = window.sessionStorage;
    this.localStorage = window.localStorage;
  }

  add(key, value, type = 'local') {
    let o = value;
    const storage = this[`${type}Storage`];
    if (typeof value === 'object') {
      o = JSON.stringify(value);
    }
    storage.setItem(key, o);
    eventProxy.emit(`storage-change.${key}`, value);
  }

  get(key, type = 'local') {
    const storage = this[`${type}Storage`];
    let value = storage.getItem(key);
    try {
      value = JSON.parse(value);
    } catch (e) {
      // error
    }

    if (!value && fields[key]) {
      value = fields[key].defaultValue;
    }
    return value;
  }

  del(key, type = 'local') {
    const storage = this[`${type}Storage`];
    storage.removeItem(key);
  }

  flush(type = 'local') {
    const storage = this[`${type}Storage`];
    storage.clear();
  }

  static getDefaultValue(key) {
    const field = fields[key];
    return field && field.defaultValue;
  }

  static transferValType(key, val) {
    const field = fields[key];
    if (field) {
      val = field.type(val);
    }
    return val;
  }

  static onChange(key, callback) {
    eventProxy.on(`storage-change.${key}`, callback);
  }
}

export default new Store();

export const Storage = Store;
